<template>
    <rkm-row>
        <rkm-col>
            <rkm-form-checkbox-group
                v-model="model.condicoes"
            >
                <rkm-form-checkbox
                    v-for="condicao in form.condicoes"
                    :key="condicao.id"
                    :value="condicao.id"
                    class="w-50 m-0"
                    :disabled="model.exportacao"
                >
                    {{ condicao.descricao }}
                </rkm-form-checkbox>
            </rkm-form-checkbox-group>
        </rkm-col>
    </rkm-row>
</template>

<script>
export default {
    data: () =>({}),
    props: {
        model: { type: Object, required: false },
        form: { type: Object, required: false }
    }
}
</script>